'use client';

import { Mail } from 'lucide-react';
import Link from 'next/link';

// Landing page navigation for non-authenticated users
export function NosemailNavigation() {
	return (
		<nav className="bg-white border-b border-gray-200 sticky top-0 z-50">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<div className="flex justify-between items-center h-16">
					{/* Logo */}
					<Link href="/" className="flex items-center space-x-2">
						<Mail className="h-8 w-8 text-emerald-600" />
						<span className="text-xl font-bold text-gray-900">NOS Email</span>
					</Link>

					{/* Public Navigation Links */}
					<div className="flex items-center space-x-4">
						<Link
							href="/login"
							className="text-gray-600 hover:text-gray-900 px-3 py-2 rounded-md text-sm font-medium transition-colors"
						>
							Sign In
						</Link>
						<Link
							href="/signup"
							className="bg-emerald-600 hover:bg-emerald-700 text-white px-4 py-2 rounded-md text-sm font-medium transition-colors"
						>
							Get Started
						</Link>
					</div>
				</div>
			</div>
		</nav>
	);
}
